import { confirm, notification, message as pcMessage } from '@ts-max/antd';
import { type SuccessTip, SuccessTipMode } from '@ts-max/axios';
import { t } from 'i18next';
import { isValidElement, type ReactNode } from 'react';

/**
 * 展示成功提示
 * @param options
 */
export function showSuccess(options: SuccessTip | string | ReactNode) {
  if (!options) return;

  let title = t('common:success');
  let mode = SuccessTipMode.message;
  let message: ReactNode | string | undefined;

  if (typeof options === 'string') {
    message = options;
  }

  if (isValidElement(options)) {
    message = options;
  }

  if (typeof options === 'object' && !isValidElement(options)) {
    title = (options as SuccessTip).title || title;
    mode = (options as SuccessTip).mode || mode;
    message = (options as SuccessTip).content;
  }

  if (!message) return;

  if (mode === SuccessTipMode.message) {
    pcMessage.success(message).then(() => {});
  }

  if (mode === SuccessTipMode.notification) {
    notification.success({
      title: title,
      description: message,
    });
  }

  if (mode === SuccessTipMode.modal) {
    confirm({
      title: title,
      content: message,
      okText: t('common:acknowledged'),
    }).then(() => {});
  }
}
